import React from 'react';
import { toast } from 'react-toastify';
import { actions } from 'react-redux-form';
import irelandApi from '../irelandApi';
import store, { history } from '../store';
import ToastMessage from '../components/common/toast-message';
import { removeNullFieldsFromJson } from '../utils/commonFunctions';

const createRequestData = (payLoad) => {
  const navigationLinkData = removeNullFieldsFromJson(payLoad);
  let allGroups = false;
  let permissions = [];
  let groupIds = [];

  if (navigationLinkData.permission_ids) {
    permissions = Object.keys(navigationLinkData.permission_ids).filter(key => navigationLinkData.permission_ids[key].checked);
  }

  if (navigationLinkData.groups) {
    groupIds = navigationLinkData.groups.map(curr => curr.value);

    if (groupIds.includes('all')) {
      allGroups = true;
      groupIds = [];
    }
  }

  const navigationLink = {
    name: navigationLinkData.name,
    url: navigationLinkData.url,
    login_status: navigationLinkData.login_status,
    group_ids: groupIds,
    all_groups: allGroups,
    permission_ids: permissions
  };

  return navigationLink;
};

export const getNavigationLinks = () => (dispatch) => {
  dispatch({type: 'GET_NAVIGATIONLINK_LIST_PENDING'});
  return irelandApi.get('/api/admin/navigation_links')
    .then((response) => {
      dispatch({type: 'GET_NAVIGATIONLINK_LIST_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_NAVIGATIONLINK_LIST_REJECTED', payLoad: error.data});
    });
};

export const reorderNavigationLinks = payLoad => (dispatch) => {
  dispatch({type: 'REORDER_NAVIGATIONLINKS_FULFILLED', payLoad: {data: payLoad}});
  const data = {
    order: payLoad.map(item => +item.id)
  };
  return irelandApi.patch('/api/admin/navigation_links/change_order', {navigation_link: data})
    .then(() => {
      toast.info(<ToastMessage iconStyle="info" message="Navigation link order modified"/>, {autoClose: 2000});
    })
    .catch((error) => {
      toast.warn(<ToastMessage iconStyle="warning" message="Unable to set navigation link order"/>, {autoClose: 2000});
      dispatch({type: 'REORDER_NAVIGATIONLINKS_REJECTED', payLoad: error.data});
    });
};

export const getNavigationLinkBaseData = () => (dispatch) => {
  dispatch({type: 'INITIALIZE_ADD_NAVIGATIONLINK_PENDING'});
  return irelandApi.get('/api/admin/navigation_links/new')
    .then((response) => {
      const { data: { meta } } = response;

      dispatch({type: 'INITIALIZE_ADD_NAVIGATIONLINK_FULFILLED', payLoad: meta});
    })
    .catch((error) => {
      dispatch({type: 'INITIALIZE_ADD_NAVIGATIONLINK_REJECTED', payLoad: error.data});
    });
};

export const getNavigationLink = id => (dispatch) => {
  dispatch({type: 'GET_NAVIGATIONLINK_PENDING', payLoad: []});
  return irelandApi
    .get(`/api/admin/navigation_links/${id}`)
    .then((response) => {
      const { data: { data: { attributes } } } = response;
      const data = {
        name: attributes.name || '',
        url: attributes.url || '',
        login_status: attributes['login-status'] || '',
        group_ids: attributes['group-ids'] || [],
        groups: attributes.groups || [],
        permissions: attributes.permissions || []
      };
      store.dispatch(actions.load('deep.admin_navigationlink', data));
      dispatch({type: 'GET_NAVIGATIONLINK_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_NAVIGATIONLINK_REJECTED', payLoad: error.data});
    });
};

export const saveNavigationLink = payLoad => irelandApi.post('/api/admin/navigation_links/', {navigation_link: createRequestData(payLoad)})
  .then(() => {
    toast.success(<ToastMessage iconStyle="success" message="Navigation link saved successfully"/>);
    history.push('/admin/navigation/links');
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save navigation link"/>);
    store.dispatch(actions.resetValidity('deep.admin_navigationlink'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const updateNavigationLink = (id, payLoad) =>
  irelandApi.patch(`/api/admin/navigation_links/${id}`, {navigation_link: createRequestData(payLoad)})
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Navigation link saved successfully"/>);
      history.push('/admin/navigation/links');
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save navigation link"/>);
      store.dispatch(actions.resetValidity('deep.admin_navigationlink'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });

export const deleteNavigationLink = id => (dispatch) => {
  dispatch({type: 'DELETE_NAVIGATIONLINK_PENDING'});
  return irelandApi.delete(`/api/admin/navigation_links/${id}`)
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Navigation link has been deleted successfully"/>);
      dispatch({type: 'DELETE_NAVIGATIONLINK_FULFILLED', payLoad: id});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during navigation link delete"/>);
      dispatch({type: 'DELETE_NAVIGATIONLINK_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data
      };
      return Promise.reject(data);
    });
};



// WEBPACK FOOTER //
// ./src/actions/navigationlinks.js